import React, { FC } from 'react'
import { FeatureVideo } from '@components/FeatureVideo'
import {
  ProductCardSection,
  ProductCardProps
} from '@pages/Homepage/components/ProductCardSection'
import {
  MOBILE_WIDTH,
  MOBILE_HEIGHT,
  DESKTOP_WIDTH,
  DESKTOP_HEIGHT,
} from './constants'
import {
  FeatureVideoSectionContainer,
  InnerContent,
  Overlay,
  OverlayTitle,
  ProductSelectTopText,
  ProductSelectBottomText,
  FeatureVideoWrapper,
} from './FeatureVideoSection.elements'

type Props = {
  title: string
  mobileUrl: string
  mobileWidth: number
  mobileHeight: number
  mobileFallbackUrl: string
  desktopUrl: string
  desktopWidth: number
  desktopHeight: number
  desktopFallbackUrl: string
  productCards: ProductCardProps[]
  onGetMyQuote: (cardType: 'MEDSUP' | 'MEDADV' | 'LIFE_INSURANCE' | 'QUIZ' | 'AUTO_INSURANCE') => void
}

export const FeatureVideoSection: FC<Props> = ({
  title,
  productCards,
  onGetMyQuote,
  mobileWidth = MOBILE_WIDTH,
  mobileHeight = MOBILE_HEIGHT,
  desktopWidth = DESKTOP_WIDTH,
  desktopHeight = DESKTOP_HEIGHT,
  ...videoProps
}) => (
  <FeatureVideoSectionContainer>
    <InnerContent>
      <FeatureVideoWrapper>
        <FeatureVideo
          {...videoProps}
          mobileWidth={mobileWidth}
          mobileHeight={mobileHeight}
          desktopWidth={desktopWidth}
          desktopHeight={desktopHeight}
        />
      </FeatureVideoWrapper>

      <Overlay>
        <OverlayTitle>{title}</OverlayTitle>
        { productCards &&
          <div>
            <ProductSelectTopText>SELECT A PRODUCT TO SEE YOUR QUOTES</ProductSelectTopText>
            <ProductCardSection
              data={productCards}
              onGetMyQuote={onGetMyQuote}
            />
            <ProductSelectBottomText>Special rate savings only for Life &amp; Medicare Supplement Insurance.</ProductSelectBottomText>
          </div>
        }
      </Overlay>
    </InnerContent>
  </FeatureVideoSectionContainer>
)
